import { styled } from "@mui/system";
import { Link, Typography, useTheme } from "@mui/material";

export const HeaderMainDiv = styled("div")(() => ({
  height: "60px",
  width: "100%",
}));

export const HeaderBorderDiv = styled("div")(() => ({
  width: "100%",
  borderTop: `2px solid ${useTheme().custom.colors.headerTopBorderColor}`,
}));

export const HeaderLink = styled(Link)(() => ({
  ...useTheme().custom.styles.headerContactUs,
  textDecoration: "none",
}));

export const SecondaryHeaderTypography = styled(Typography)(() => ({
  ...useTheme().custom.styles.headerTitle,
  [useTheme().breakpoints.down("md")]: {
    fontSize: "24px",
  },
  [useTheme().breakpoints.up("lg")]: {
    marginLeft: "16.666666667%",
  },
  [useTheme().breakpoints.down("lg")]: {
    marginLeft: "0px",
  },
  paddingLeft: "0px !important"

}));

export const HeaderTextWrapper = styled("div")(() => ({
  [useTheme().breakpoints.down("md")]: {
    margin: "1rem",
  },
  [useTheme().breakpoints.up("md")]: {
    margin: "1rem 5rem",
  },
}));
export const HeaderInnerWrapper = styled("div")(() => ({
    margin: "0 auto",
    maxWidth: "1280px"
}));



